import axios from 'axios';

// Base URL falls back to window.cabinetVars if available (WP environment),
// otherwise uses a dev URL or relative path for Next.js in the future.
const getBaseUrl = () => {
  if (typeof window !== 'undefined' && window.cabinetVars?.wpApiUrl) {
    return window.cabinetVars.wpApiUrl;
  }
  return '/wp-json/api_front/v1'; // Fallback / Dev default
};

export const jwtUrl = () => {
    if (typeof window !== 'undefined' && window.cabinetVars?.jwtUrl) {
        return window.cabinetVars.jwtUrl;
    }
    return '/wp-json/jwt-auth/v1/token';
};

export const client = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authClient = axios.create({
    baseURL: '', // URL is constructed dynamically for auth
    headers: {
      'Content-Type': 'application/json',
    },
});

// Request interceptor to add token and prevent caching
client.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('cab_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Prevent browser/CDN caching for all GET requests
  if (config.method === 'get') {
    config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
    config.headers['Pragma'] = 'no-cache';
    config.headers['Expires'] = '0';
  }

  return config;
});

// Response interceptor to handle 401 and auto-refresh
client.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If error is 401 and we haven't retried yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('cab_refresh');

      if (refreshToken) {
        try {
          // Send request to /jwt-auth/v1/login/access-token as implemented in class-jwt-handler.php
          const refreshEndpoint = typeof window !== 'undefined' && window.cabinetVars?.siteUrl 
              ? `${window.cabinetVars.siteUrl}/wp-json/jwt-auth/v1/login/access-token` 
              : '/wp-json/jwt-auth/v1/login/access-token';
          
          // Use authClient to avoid infinite loop with client interceptors
          const response = await authClient.post(refreshEndpoint, { refreshToken: refreshToken });

          if (response.data && response.data.token) {
             const newToken = response.data.token;
             sessionStorage.setItem('cab_token', newToken);
             originalRequest.headers.Authorization = `Bearer ${newToken}`;
             return client(originalRequest);
          }
        } catch (refreshError) {
          // Refresh failed, user needs to log in again
          sessionStorage.removeItem('cab_token');
          localStorage.removeItem('cab_refresh');
          // Dispatch event so AuthContext can log out the user
          window.dispatchEvent(new Event('cabinet_auth_expired'));
        }
      } else {
          // No refresh token available
          window.dispatchEvent(new Event('cabinet_auth_expired'));
      }
    }
    return Promise.reject(error);
  }
);
